import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const team = [
  {
    name: 'Amresh Kumar',
    role: 'Founder & CEO',
    emoji: '👨‍💼',
    desc: 'Visionary leader with 6+ years in digital marketing. Drives strategy, innovation, and client success at DMS.',
    skills: ['Strategy', 'Business Development', 'Client Relations'],
  },
  {
    name: 'Digital Media Team',
    role: 'Social Media Managers',
    emoji: '📱',
    desc: 'Creative professionals managing 93+ social media accounts with consistent growth and engagement results.',
    skills: ['Content Creation', 'Instagram', 'Facebook'],
  },
  {
    name: 'Web Dev Team',
    role: 'Website Developers',
    emoji: '💻',
    desc: 'Expert developers who have built 300+ websites ranging from business sites to full e-commerce platforms.',
    skills: ['React', 'WordPress', 'E-Commerce'],
  },
  {
    name: 'Design Studio',
    role: 'Graphic Designers',
    emoji: '🎨',
    desc: 'Creative minds behind every logo, banner, and brand identity that our clients love and use daily.',
    skills: ['Branding', 'UI/UX', 'Motion Graphics'],
  },
  {
    name: 'Performance Team',
    role: 'Ads & PPC Specialists',
    emoji: '🎯',
    desc: 'Data-driven specialists managing high-ROI Google Ads and Meta Ads campaigns for clients across India.',
    skills: ['Google Ads', 'Meta Ads', 'Analytics'],
  },
  {
    name: 'SEO Department',
    role: 'SEO Analysts',
    emoji: '🔍',
    desc: 'Search engine experts driving organic traffic and top Google rankings for our clients\' businesses.',
    skills: ['On-Page SEO', 'Link Building', 'Technical SEO'],
  },
];

export default function Team() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-page">

      {/* HERO */}
      <section className="page-hero">
        <div className="container page-hero-content hero-animate">
          <span className="section-tag">The People Behind DMS</span>
          <h1>Meet Our <span>Team</span></h1>
          <p>A passionate team of digital experts dedicated to growing your business online with creativity, data, and results.</p>
        </div>
      </section>

      {/* TEAM GRID */}
      <section style={{ padding: '90px 0' }}>
        <div className="container">
          <div className="team-grid">
            {team.map((member, i) => (
              <div className="team-card animate-on-scroll" key={i}>
                <div className="team-emoji">{member.emoji}</div>
                <h3>{member.name}</h3>
                <span className="team-role">{member.role}</span>
                <p>{member.desc}</p>
                <div className="team-skills">
                  {member.skills.map((s, j) => (
                    <span className="team-skill-tag" key={j}>{s}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="team-cta-section">
        <div className="container">
          <div className="team-cta-card animate-on-scroll">
            <h2>Want to Work with Our <span>Expert Team?</span></h2>
            <p>Let's talk about your business goals and how we can help you achieve them.</p>
            <Link to="/contact" className="btn-primary">Get Free Consultation →</Link>
          </div>
        </div>
      </section>

    </div>
  );
}
